import React, { useMemo } from 'react';

import { Box } from '@material-ui/core';

import { AppSearchInput } from '@vyce/core/src/components/inputs';
import { WorkersScrollList } from '@vyce/core/src/components/WorkersScrollList';
import { useCompanyWorkersList } from '@vyce/core/src/hooks/useCompanyWorkersList';
import { CompanyWorkerItem } from '@vyce/core/src/types';

import { FormExistingMemberRow } from './FormExistingMemberRow';

interface Props {
  companyId: string;
  selectedWorkers: CompanyWorkerItem[];
  toggleWorker: (worker: CompanyWorkerItem) => void;
  maxHeight?: number | string;
}

export const FormExistingMembersList: React.FC<Props> = ({
  companyId,
  selectedWorkers,
  toggleWorker,
  maxHeight = 360,
}) => {
  const { search, setSearch, workers, loading, loadingMore, loadMore } = useCompanyWorkersList({
    companyId,
    // Recipient rows show no onboarding state — skip that server-side lookup
    includeOnboarding: false,
  });

  const selectedIds = useMemo(
    () => new Set(selectedWorkers.map(worker => worker.user_id)),
    [selectedWorkers]
  );

  return (
    <Box display="flex" flexDirection="column" gridGap={16}>
      <AppSearchInput
        value={search}
        onChange={event => setSearch(event.target.value)}
        placeholder="Search team members..."
        isSmall
        smallRounding
        isBorder
        expanded
        fullWidth
      />

      <WorkersScrollList
        workers={workers}
        loading={loading}
        loadingMore={loadingMore}
        onLoadMore={loadMore}
        maxHeight={maxHeight}
        emptyText="No team members found."
        renderRow={worker => (
          <FormExistingMemberRow
            key={worker.user_id}
            worker={worker}
            checked={selectedIds.has(worker.user_id)}
            onToggle={() => toggleWorker(worker)}
          />
        )}
      />
    </Box>
  );
};
